
import { Navigate } from "react-router-dom";

// This component redirects from the old Index route to our Home page
const Index = () => {
  return <Navigate to="/home" replace />;
};

export default Index;
